import React, { Fragment } from 'react';
import {
    DetailedManualEntry,
    MultiDayManualEntry,
    StatutoryEntry
} from 'pages/employee-settings/manual-entry-templates/shared';
import { NotificationInline } from 'components/notifications';
import { ManualEntryService } from 'services';

export function ManualEntryTemplateActivities({
    templateType,
    template,
    infringements,
    onActivitiesValidChange,
    onTemplateUpdate,
    editMode = false
}) {
    
    function onActivitiesChange(activities) {
        onTemplateUpdate({ activities });
    }

    function onMultiDayActivitiesChange(days) {
        onTemplateUpdate({ days: days.sort((a, b) => a.dayNumber - b.dayNumber) });
    }

    function onStatutoryDaysChange(dayNumbers) {
        onTemplateUpdate({ dayNumbers });
    }

    


    return (
        <Fragment>
            <NotificationInline
                show={infringements && infringements?.length > 0}
                text={(
                    <>
                        {`${editMode ? "This" : "Your"} template will generate the following infringement(s) if applied: ${ManualEntryService.groupInfringementCodes(infringements)}`}
                    </>
                )}
                intent='danger'
                allowClose={false}
            />
            {templateType === "MANUALENTRYSINGLE" && (
                <DetailedManualEntry
                    originalActivities={template.activities ?? []}
                    onValidChange={onActivitiesValidChange}
                    onActivitiesChange={onActivitiesChange}
                    editMode={editMode}
                />
            )}
            {templateType === "MANUALENTRYMULTI" && (
                <MultiDayManualEntry
                    activities={template.days ?? []}
                    onValidChange={onActivitiesValidChange}
                    onActivitiesUpdate={onMultiDayActivitiesChange}
                    infringements={infringements}
                    editMode={editMode}
                />
            )}
            {(templateType === "STATWEEKHOLIDAY" || templateType === "STATWEEKSICKNESS") && (
                <StatutoryEntry
                    statutoryDays={template?.dayNumbers ?? []}
                    onStatutoryDaysChange={onStatutoryDaysChange}
                    onValidChange={onActivitiesValidChange}
                    editMode={editMode}
                />
            )}
        </Fragment>
    );
}
